<div class="table-container">
    <h1>Options</h1>
    <table [dataSource]="matDatasource" class="mat-elevation-z8 container-fluid" mat-table matSort>

        <!-- select Column -->
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef> Is Option Selected? </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox (change)="toggleSelection(row)"
                              [checked]="selection.isSelected(row)"
                              [disabled]="isReadOnly"></mat-checkbox>
            </td>
        </ng-container>

        <!-- Key Column -->
        <ng-container matColumnDef="key">
            <th *matHeaderCellDef mat-header-cell mat-sort-header> Option Name</th>
            <td mat-cell *matCellDef="let element"> {{element.key}} </td>
        </ng-container>

        <!-- Value Column -->
        <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef> Option Value </th>
            <td mat-cell *matCellDef="let element">
                <input *ngIf="isNumberType(element)"
                       id="valueNumber{{element.key}}"
                       (change)="changed(element, 'value', $event.target.value)" required="false" [disabled]="isNotEditable(element)" [readonly]="isNotEditable(element)" value="{{element.value}}" type="number"/>
                <input *ngIf="isStringTypeOrNull(element)"
                       id="valueString{{element.key}}"
                       (change)="changed(element, 'value', $event.target.value)" required="false" [disabled]="isNotEditable(element)" [readonly]="isNotEditable(element)" value="{{element.value}}" type="text"/>
                <mat-slide-toggle *ngIf="isBooleanType(element)"
                           [disabled]="isNotEditable(element)" [checked]="isStringValueTrue(element.value)"
                           (toggle)="toggled(element)"></mat-slide-toggle>
                <select *ngIf="isPredefinedValues(element)"
                        id="valueSelect{{element.key}}"
                        (change)="changed(element, 'value', $event.target.value)" required="false" [disabled]="isNotEditable(element)">
                    <option *ngFor="let predefinedValue of element.predefinedValues" value="{{predefinedValue}}" [selected]="predefinedValue.trim()==element.value">
                        {{predefinedValue.trim()}}</option>
                </select>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>
